<template>
  <table ref="table" class="table-package">
    <slot></slot>
  </table>
</template>

<script>
export default {
  name: "TableEx",
  props: {
    showIndex: {
      type: Boolean,
      default: false,
    },
    enable: {
      default: true,
      type: Boolean,
    },
  },
  updated() {
    this.lock();
  },
  methods: {
    lock() {
      function disable(elements, enable) {
        for (let index = 0; index < elements.length; index++) {
          const element = elements[index];
          element.disabled = !enable;
          if (
            element.className.indexOf("addRow") > -1 ||
            element.className.indexOf("dropdownIcon") > -1
          ) {
            element.style.display = enable ? "" : "none";
          }
          disable(element.children, enable);
        }
      }
      disable(this.$refs.table.children, this.enable);
    },
  },
};
</script>

<style lang="stylus" scoped>
.table-package
  // margin 0 auto
  // min-width 1000px
  width 100%
  border-collapse collapse
  // border 1px #ddd solid
</style>
